import { z } from "zod";

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
const jsonSchema = z.lazy(() =>
  z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)])
);

export const stringToJSONSchema = z.string().transform((str, ctx) => {
  if (!str) {
    return z;
  }
  try {
    return JSON.parse(str);
  } catch (e) {
    ctx.addIssue({ code: "custom", message: "Invalid JSON" });
    return z.NEVER;
  }
});

// for use with date inputs that can be cleared
export const requiredString = (message) =>
  z
    .string()
    .nullable()
    .refine((value) => value !== null, {
      message,
      params: {
        code: z.ZodIssueCode.invalid_type,
        expected: "string",
        received: "null",
      },
    });

export const coerceToNumber = (v) =>
  v === "" || v === null || v === undefined ? null : Number(v);
